module.exports = __webpack_public_path__ + "images/emoji/oncoming_taxi.9a287adfd149ec78206d.png";